export function getKidsCraftsLink(template?: string): string {
  return template || '<a target="_blank" href="https://kidscrafts.shop">KidsCrafts.shop</a>'
}

export function getPrimaryKidsCraftsLink(): string {
  return `<span class="underline text-primary">${getKidsCraftsLink()}</span>`
}
